import { render, staticRenderFns } from "./merchant_categories.vue?vue&type=template&id=1606e439&"
import script from "./merchant_categories.vue?vue&type=script&lang=js&"
export * from "./merchant_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports